// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const TooltipContract = contract({
  name: "Tooltip",
  description: "A short, non-essential label that explains a control on hover/focus — icon-only buttons in toolbars, abbreviated column headers, status dots. NEVER hide critical info inside a tooltip — they're invisible on touch and can be skipped by screen readers if implemented carelessly. For richer hover content use HoverCard. For inline help text that's always visible, use a description paragraph.",
  import: "@gradeui/ui",
  aliases: ["tooltip","tip","hover tip","hint","label on hover","help tag","hint","helper text bubble","info tip"],
  subcomponents: ["TooltipTrigger","TooltipContent","TooltipProvider"],
  composesWith: ["Button (icon-only)","Toggle","TabsTrigger (the canonical tabs already have a `tooltip` prop that wraps this)","Avatar (status badge meaning)"],
  styleDefaults: {"TooltipContent":"z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-tooltip-content-transform-origin)"},
  props: {
  "delayDuration": {
      schema: z.number().optional(),
      design: "knob",
      description: "ms hover before show; mount ONCE near the app root",
  },
  "skipDelayDuration": {
      schema: z.number().optional(),
      design: "knob",
      description: "ms gap that still feels like \"same hover\"",
  },
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "defaultOpen": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "usually wraps a Button or icon",
  },
  "side": {
      schema: z.enum(["top", "right", "bottom", "left"]).optional(),
      design: "knob",
      default: "top",
  },
  "align": {
      schema: z.enum(["start", "center", "end"]).optional(),
      design: "knob",
  },
  "sideOffset": {
      schema: z.number().optional(),
      design: "knob",
  },
  },
});
